export const listingDetail = {
  breadcrumb: {
    listings: "Oferty",
    detailFallback: "Szczegóły",
  },
  hero: {
    noName: "Bez nazwy",
    editNameTitle: "Edytuj nazwę",
    channelConnected: "Połączono z channel managerem (OTA)",
    channelDisconnected: "Brak połączenia z channel managerem",
  },
  units: {
    unitsCount: "Jednostki: {count}",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    maxGuests: "Maks. {count} gości",
    searchPlaceholder: "Szukaj jednostki…",
    dragTitle: "Przeciągnij, aby zmienić kolejność",
    headerRoomTypes: "TYPY POKOI",
    headerLinkedUnits: "POWIĄZANE JEDNOSTKI",
    addBtnTitle: "Dodaj jednostkę",
    movedBadge: "przeniesiono",
    unitFallback: "Jednostka",
  },
  typeLabels: {
    apartment: "Apartament",
    house: "Dom",
    villa: "Willa",
    hotel: "Hotel",
    room: "Pokój",
    studio: "Kawalerka",
    fallback: "Obiekt",
  },
  aiReception: {
    title: "Recepcja AI",
  },
  toggles: {
    enableAgent: {
      label: "Włącz agenta AI",
      hint: "Automatyzacja obsługi gości przez WhatsApp.",
    },
    otaAgent: {
      label: "Agent AI dla OTA",
      hintOn: "Odpowiada także na wiadomości z Booking, Airbnb i innych OTA.",
      hintOff: "Wymaga aktywnego agenta AI.",
    },
  },
  status: {
    active: "Aktywny",
    inactive: "Nieaktywny",
  },
  emptyUnits: {
    title: "Brak jednostek",
    subHotel: "Utwórz pierwszy pokój lub jednostkę tego hotelu, aby zacząć konfigurować stawki i dostępność.",
    subDefault: "Dodaj pierwszą jednostkę do tej oferty, aby zacząć przyjmować gości.",
    ctaPreparing: "Przygotowywanie…",
    ctaAddRoom: "Dodaj pokój",
    ctaAddFirstUnit: "Dodaj pierwszą jednostkę",
  },
  sortBar: {
    add: "Dodaj",
    addRoom: "Dodaj pokój",
    saving: "Zapisywanie…",
    done: "Gotowe",
    sort: "Zmień kolejność",
    dragHint: "Przeciągnij, aby zmienić kolejność",
  },
  propOptions: {
    scheduled: "Zaplanowane wiadomości",
    services: "Wyposażenie i udogodnienia",
    locks: "Zamki",
    faq: "Pytania i odpowiedzi",
    arrival: "Instrukcje dojazdu",
    checkout: "Wiadomość o check-out",
    welcome: "Wiadomość powitalna",
    description: "Opis",
    capacity: "Pojemność",
  },
  addZone: {
    titleRoom: "Dodaj pokój",
    titleUnit: "Dodaj jednostkę",
    roomLower: "pokój",
    unitLower: "jednostka",
    createNew: "Utwórz wewnątrz nowy element typu {noun}",
    eachHas: "Każdy element typu {noun} ma własne ustawienia (opis, pojemność, dostęp…).",
    ctaPreparing: "Przygotowywanie…",
    ctaCreateRoom: "Utwórz pokój",
    ctaCreateUnit: "Utwórz jednostkę",
  },
  danger: {
    deleteListing: "Usuń ofertę...",
    notePrefix: "Usuwa ofertę",
    noteSuffix: " oraz wszystkie jej jednostki z WACheckin. Tej operacji nie można cofnąć.",
  },
  toast: {
    orderSaved: "Kolejność została zapisana",
  },
  errors: {
    loadListing: "Nie udało się wczytać obiektu.",
  },
  authorities: {
    title: "Organy publiczne",
    description: "Konfiguracja połączenia z lokalnymi organami w celu automatycznego zgłaszania gości.",
  },
  cards: {
    knowledge: { title: "Baza wiedzy", status: "Informacje wykorzystywane przez agenta" },
    earlyAccess: { title: "Wcześniejszy dostęp", status: "Godziny przyjazdu i wcześniejszy check-in" },
    lateCheckout: { title: "Późny check-out", status: "Późny check-out i cena" },
    extendStay: { title: "Przedłużenie pobytu", status: "Wydłużenie liczby nocy w rezerwacji" },
    invoicing: { title: "Fakturowanie", status: "Dane podatkowe · zgodne z Verifactu" },
    location: { title: "Lokalizacja", sub: "Adres obiektu" },
    logo: { title: "Identyfikacja wizualna", sub: "Znak i kolory marki" },
    welcome: { title: "Wiadomość powitalna", sub: "Personalizacja powitania" },
    checkin: { title: "Check-in", sub: "Instrukcje wejścia i godziny" },
    policies: { title: "Regulamin obiektu", sub: "Zasady i warunki" },
    authorities: { sub: "Zgłoszenia do organów publicznych" },
    hotelRates: { title: "Stawki hotelowe", sub: "Stawki bazowe i pochodne" },
    roomManagement: { title: "Pokoje", sub: "Typy pokoi i inwentarz" },
    rates: { title: "Stawki", sub: "Stawki bazowe i pochodne" },
    ota: { title: "Podłącz OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Wymaga aktywnej subskrypcji" },
    ical: { title: "Kalendarz iCal", sub: "Synchronizacja kalendarzy" },
    ownerSettlement: { title: "Właściciel i rozliczenie", sub: "Jeśli zarządzasz nim dla innego właściciela: prowizja i rozliczenie", subManaged: "Właściciel: {owner} · {pct}%", subManagedNoOwner: "Zarządzany · {pct}% · brak przypisanego właściciela" },
    otaCommissions: { title: "Prowizje OTA", sub: "Ile zatrzymuje każda OTA i ile do Ciebie trafia", subActive: "Karta rezerwacji pokazuje, ile do Ciebie trafia" },
    description: { title: "Opis", sub: "Szczegóły jednostki" },
    capacity: { title: "Pojemność", sub: "Goście i łóżka" },
    services: { title: "Wyposażenie i udogodnienia", sub: "Co oferuje, ze zdjęciami" },
    unitFaq: { title: "Pytania i odpowiedzi", sub: "Dotyczące tej jednostki, dla agenta" },
    rules: { title: "Godziny", sub: "Godziny check-in i check-out" },
    upselling: { title: "Doświadczenia i usługi", sub: "Usługi sprzedaży dodatkowej" },
    checkinStore: { title: "Sklep przy zameldowaniu", sub: "Wyślij gościowi przy przyjeździe" },
    bookingConfirmation: { title: "Powiadom o nowej rezerwacji", sub: "Powiadamiamy gościa na WhatsApp, gdy jego rezerwacja zostanie potwierdzona" },
    arrivalInstructions: { title: "Instrukcje dojazdu", sub: "Jak dojechać i wejść · z godziną wysyłki" },
    checkoutMessage: { title: "Wiadomość o check-out", sub: "Przypomnienie o check-out · szablon" },
    scheduledMessages: { title: "Zaplanowane wiadomości", sub: "Automatyczne wiadomości przed, w trakcie i po pobycie" },
    review: { title: "Poproś o opinię", sub: "Reputacja obiektu" },
    identity: { title: "Weryfikacja tożsamości", sub: "Bezpieczeństwo gości" },
    journeySim: { title: "Symuluj ścieżkę gościa", sub: "Odtwarza cały proces na WhatsApp · wyślij na telefon, aby przetestować" },
    smartlocks: { title: "Zamki i dostęp", sub: "Jak gość dostaje się do środka" },
    integrations: { title: "Połączenia i integracje", sub: "Dodatkowe API i połączenia" },
    welcomeInline: { sub: "Wiadomość właściwa dla tej jednostki" },
    newBookings: { title: "Nowe rezerwacje" },
  },
  badges: {
    ai: "AI",
    setup: "Konfiguracja",
    hotel: "Hotel",
    subscription: "Subskrypcja",
    comingSoon: "Wkrótce",
    test: "Test",
    manager: "Zarządca",
    active: "Aktywne",
  },
  sections: {
    essential: { title: "Konfiguracja podstawowa", description: "Ustawienia niezbędne do publikacji obiektu i zarządzania nim." },
    management: { title: "Zarządzanie obiektem", description: "Konfiguracja stawek, dostępności i kanałów sprzedaży." },
    direct: { title: "Szczegóły tej jednostki", description: "Dodatkowe informacje wykorzystywane przy rezerwacjach bezpośrednich i przez agenta AI." },
    guest: { title: "Doświadczenie gościa", description: "Konfiguracja komunikacji przed pobytem, w jego trakcie i po nim." },
    access: { title: "Dostęp i integracje", description: "Zarządzanie dostępem, zamkami i połączeniami zewnętrznymi." },
  },
  otaModal: {
    title: "Połączenie z OTA",
    html: "Podłączenie Booking, Airbnb, Vrbo, Expedia (channel manager) wymaga <b>aktywnej subskrypcji</b>.<br><small>W międzyczasie dostępne są pozostałe funkcje oraz synchronizacja kalendarzy przez iCal (bezpłatnie).</small>",
    confirm: "Aktywuj subskrypcję",
    cancel: "Nie teraz",
  },
};
